module.exports = "/dog-racing/img/second-dog.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img/second-dog.png
// module id = 1957
// module chunks = 7